import { http } from '@/lib/http';
import type { APIResponse, APIResponseResultCursor, CursorPaginationParams, UserDesignItem } from '@/types';

export type GetUserDesignsParams = {
  gfWorkId?: number;
  gfProductId?: number;
  sort?: string;
} & CursorPaginationParams;

type GetUserDesignsResponse = APIResponse<APIResponseResultCursor<UserDesignItem>>;

/**
 * ユーザーデザイン一覧を取得（カーソルページネーション対応）
 */
export const getUserDesigns = async (params?: GetUserDesignsParams): Promise<GetUserDesignsResponse> => {
  return await http<GetUserDesignsResponse>('/user/v1/gf/user-designs', {
    method: 'GET',
    query: {
      gf_work_id: params?.gfWorkId,
      gf_product_id: params?.gfProductId,
      limit: params?.limit,
      sort: params?.sort,
      last_id: params?.lastId,
      direction: params?.direction,
    },
  });
};
